/** @internal */
export const OP_BACKPRESSURE_STRATEGY = "BackPressure";
/** @internal */
export const OP_DROPPING_STRATEGY = "Dropping";
/** @internal */
export const OP_SLIDING_STRATEGY = "Sliding";
//# sourceMappingURL=strategy.js.map